module.exports = __webpack_public_path__ + "img/diagram-venn.ac46f0ec.svg";